import { AxiosInstance, AxiosRequestConfig } from 'axios';

import { Profile } from './models/user';
const ENDPOINT = 'user/profile/';

// eslint-disable-next-line import/no-anonymous-default-export
export default (instance: AxiosInstance, config: AxiosRequestConfig) => ({
  getProfile: () => instance.get<ApiResponse<Profile>>(ENDPOINT, config),
});
